import * as types from './types';

export function storeSelectedOption(selectedOption) {
	return { type: types.STORE_OPTION, selectedOption };
}
export const optionActions = {
	storeSelectedOption
};
